import { Check } from 'lucide-react';

interface CheckMarkProps {
	isSelected: boolean;
}

const CheckMark = ({ isSelected }: CheckMarkProps) => {
	if (!isSelected) return null;

	return (
		<div className="absolute top-0 right-0 translate-x-1/2 -translate-y-1/2 z-10">
			<div className="bg-green-500 rounded-full leading-none h-5 w-5 flex items-center justify-center">
				<Check className="w-3 h-3 text-white stroke-[4]" />
			</div>
		</div>
	);
};

export default CheckMark;
